import { LitElement, html } from "lit";

import { customElement } from "lit/decorators.js";

import { styles } from "./app-layout.css";

import "../app-menu/app-menu";
import "../page-header/page-header";
import "ui-components/feedback/feedback-label";
import { t } from "../../translations/i18n";

@customElement("app-layout")
export class AppLayout extends LitElement {
  static override styles = styles;

  protected override render() {
    return html`
      <section class="container">
        <section class="menu">
          <app-menu></app-menu>
        </section>
        <main class="main">
          <slot></slot>
        </main>
        <feedback-label
          labelButtonText=${t("feedback.feedback")}
          headerText=${t("feedback.headerText")}
          sentimentMessage=${t("feedback.sentimentMessage", { context: "post" })}
          sentimentPrompt=${t("feedback.sentimentPrompt")}
          labelPrompt=${t("feedback.labelPrompt")}
          labelPlaceholder=${t("feedback.labelPlaceholder")}
          labelError=${t("feedback.labelError")}
          successMessage=${t("feedback.successMessage")}
          footerButtonText=${t("feedback.footerButtonText")}
          footerButtonLoadingText=${t("feedback.footerButtonLoadingText")}
        ></feedback-label>
      </section>
    `;
  }
}
